import BasePerimeter from './BasePerimeter';

export default new BasePerimeter({
  purpose: 'complex',

  can: {
    all() {
      return this.hasPermission('subject-read');
    },

    create() {
      return this.hasPermission('subject-write');
    },

    read() {
      return this.hasPermission('subject-read');
    },

    update(complex) {
      return this.hasPermission('subject-update') || this.isCreator(complex);
    },

    destroy() {
      return this.hasPermission('subject-delete');
    },

    matrix() {
      return this.hasPermission('export-matrix');
    }
  },

  isCreator(complex) {
    if (!complex) return false;

    return this.child.id === complex.child_id;
  }
});
